import script from "./contacts-peek-popup.vue?vue&type=script&setup=true&lang=ts"
export * from "./contacts-peek-popup.vue?vue&type=script&setup=true&lang=ts"

import "./contacts-peek-popup.vue?vue&type=style&index=0&id=9f9a9cb4&lang=scss"

const __exports__ = script;

export default __exports__